import * as React from "react";
import { useAppointmentContext } from "../../../../../context/v3/pages/BookAppointment/context/AppointmentContext.js";
import { useRoutingContext } from "../../../../../context/RoutingContext/v3/pages/BookAppointment/context/RoutingContext/context.js";
import { fromArrayToString } from "../../../../../../../utils/v3/utils/from-array-to-string.js";
const timeSlotQueryParams = () => {
  const url = new URL(window.location.href);
  const { searchParams } = url;
  const hasTimeSlotParams = searchParams.has("start") && searchParams.has("end");
  if (!hasTimeSlotParams) {
    return {};
  }
  return {
    start: searchParams.get("start"),
    end: searchParams.get("end")
  };
};
const useBookAppointmentTimeSlotWithUrlParam = () => {
  const [, { queryParams }] = useRoutingContext();
  const [{ setTimeSlot }, { timeSlot }] = useAppointmentContext();
  React.useEffect(() => {
    const { start: startFromUrl, end: endFromUrl } = queryParams;
    const start = fromArrayToString(startFromUrl);
    const end = fromArrayToString(endFromUrl);
    const { start: newQueryParamStart, end: newQueryParamEnd } = timeSlotQueryParams();
    if (newQueryParamStart !== start && newQueryParamEnd !== end) {
      return;
    }
    const hasDifferentTimeSlotFromUrl = !timeSlot || start !== `${timeSlot.from.getTime()}` || end !== `${timeSlot.until.getTime()}`;
    if (start && end && hasDifferentTimeSlotFromUrl) {
      setTimeSlot({
        from: new Date(Number(start)),
        until: new Date(Number(end))
      });
    }
  }, [queryParams, timeSlot, setTimeSlot]);
};
export {
  useBookAppointmentTimeSlotWithUrlParam as default
};
//# sourceMappingURL=use-book-appointment-time-slot-with-url-param.js.map
